














import { computed, defineComponent } from "@vue/composition-api";
import Message from "@/components/Message.vue";
import injectStrict from "@/utilities/injectstrict";
import { OrganizationKey } from "../symbols";
import IButton from "@/interfaces/IButton";

export default defineComponent({
  components: {
    Message,
  },
  setup(_, { root }) {
    const organization = injectStrict(OrganizationKey);
    return {
      primaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("organizations.show"),
          variant: "success",
          onClick: async () => {
            await root.$router.back();
            setTimeout(() => {
              root.$router.push({
                name: "Organization",
                params: { id: organization.id?.toString() ?? "" },
              });
            }, 500);
          },
        };
      }),
      secondaryButton: computed<IButton>(() => {
        return {
          title: root.$tc("common.done"),
          variant: "info",
          onClick: () => {
            root.$router.back();
          },
        };
      }),
    };
  },
});
